import React from "react";
import { HomeGreeting } from "../../styles/texts";
import CasaRuufImage from "./HomeComponents/Images/CasaRuuf.png";
import {
  UserData,
  UserBooking,
  SpecificBooking,
  UserContract,
} from "../../types/responseTypes";
import ResumeBarEntreVisitaInstall from "./HomeComponents/Resume/ResumeBarEntreVisitaInstall";

interface HomeEntreVisitaInstallProps {
  userData: UserData;
  userBooking: UserBooking;
  specificBooking: SpecificBooking;
  userContract: UserContract | null;
}
// bookingStep == 5
const HomeEntreVisitaInstall: React.FC<HomeEntreVisitaInstallProps> = ({
  userData,
  userBooking,
  specificBooking,
  userContract,
}) => {
  console.log("HomeEntreVisitaInstall");

  return (
    <div className="mb-10">

      <div className="flex flex-col items-center justify-center mb-10">
        
        <HomeGreeting userData={userData} userBooking={userBooking} />
        
        <img
          src={CasaRuufImage}
          alt="Casa Ruuf"
          className="w-1/8 md:w-1/8 mb-4"
        />
        {/* Para desarrollo local es util esto hee hee
        <div className="text-3xl font-bold text-gray-800 mb-4">
          Home Entre Visita Install
        </div>
        */}

        <div className="w-full max-w-xl md:max-w-2xl p-4 rounded-lg bg-white shadow-lg">
          <ResumeBarEntreVisitaInstall 
            userData={userData} 
            userBooking={userBooking} 
            specificBooking={specificBooking} 
            userContract={userContract}
          />
        </div>
        
      </div>
  
    </div>
  );
};

export default HomeEntreVisitaInstall;
